module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"scoringModel":"Scoring model","idCode":"ID code","name":"Name","date":"Date","result":"Result","notFound":"Not found"},"et":{"scoringModel":"Scoring model","idCode":"ID code","name":"Name","date":"Date","result":"Result","notFound":"Not found"},"ru":{"scoringModel":"Scoring model","idCode":"ID code","name":"Name","date":"Date","result":"Result","notFound":"Not found"}}')
  delete Component.options._Ctor
}
